export default function Home() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      height: '870vh',
      padding: '20px'
    }}>
      <h1>Photocall</h1>
      <p>En Photocall queremos que tus invitados puedan compartir sus fotos y acabar teniendo todos un buen recuerdo de la ocasión.</p>
      <br/>
      <p>Para más información sobre Photocall, contacta con nosotros por email <a href="mailto:tvcologan+photocall@gmail.com">AQUÍ</a></p>
    </div>
  );
}
